import React, {Component} from "react";
import {validateRequired} from "../../../shared/components/form/ValidationFunctions";
import CustomForm from "../../../shared/components/form/CustomForm";

class TrainingNotesCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        fields: {
          category: {
            type: 'select',
            label: 'Phase comments',
            rules: [validateRequired('Phase comments')],
            value: 'value',
            optionLabel: 'label',
            options: [{
              value: 'general',
              label: 'General'
            }, {
              value: 'weekly',
              label: 'Weekly'
            }]
          },

          guid: {
            type: 'select',
            label: 'Phase',
            rules: [validateRequired('Phase')],
            value: 'value',
            optionLabel: 'label',
            options: props.selectedOit.trainingPhases.map(p => ({
              value: p.trainingPhaseGuid,
              label: p.header
            }))
          },

          week: {
            type: 'select',
            label: 'Week',
            rules: [validateRequired('Week')],
            value: 'value',
            optionLabel: 'label',
            options: [{
              value: 1,
              label: 'Week 1'
            }, {
              value: 2,
              label: 'Week 2'
            }, {
              value: 3,
              label: 'Week 3'
            }, {
              value: 4,
              label: 'Week 4'
            }, {
              value: 5,
              label: 'Week 5'
            }, {
              value: 6,
              label: 'Week 6'
            }]
          },

          // start: {
          //   type: 'date',
          //   label: 'Start date (required)',
          // },
          // expected: {
          //   type: 'date',
          //   label: 'Finish date',
          // },

          comment: {
            type: 'textarea',
            label: 'Comments',
            rules: [validateRequired('Comments')],
          },
        }
      },
      initialValues: {
        guid: props.selectedOit.trainingPhases[0].trainingPhaseGuid,
        category: 'general'
      }
    }
  }

  render() {
    return (
      <div>
        <CustomForm
          config={this.state.form}
          submitAction={this.props.saveNoteAction}
          initialValues={this.props.initialValues || this.state.initialValues}
          onSuccess={() => this.props.onSuccess()}
        />
      </div>
    );
  }
}

export default TrainingNotesCreate;
